import { Tag } from "antd";
import { beautify } from "../../utils/helpers";

export const PaymentStatusTag = ({ status }) => {
  switch (status) {
    case "paid":
    case "PAID":
    case "confirmed":
    case "CONFIRMED":
    case "SUCCESS":
    case "completed":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "Active":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {beautify("Active")}
        </Tag>
      );
    case "defaulted":
    case "not_paid":
    case "FAILED":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "UNPAID":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "partially_paid":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {/* {beautify(status)} */}
          {beautify(status)}
        </Tag>
      );
    case "not_available":
      return (
        <Tag color="gray" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(status)}</Tag>;
  }
};

export const BooleanTags = ({ status }) => {
  if (status == true) {
    return (
      <Tag color="green" style={{ background: "none" }}>
        True
      </Tag>
    );
  } else {
    return (
      <Tag color="red" style={{ background: "none" }}>
        False
      </Tag>
    );
  }
};

export const ApprovalStatusTag = ({ status }) => {
  switch (status) {
    case "Approved":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "Deactivated":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "Pending":
      return (
        <Tag color="black" style={{ background: "gray" }}>
          {beautify(status)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(status)}</Tag>;
  }
};

export const StatusTag = ({ status }) => {
  switch (status) {
    case "approved":
    case "active":
      return (
        <Tag color="green" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "rejected":
      return (
        <Tag color="red" style={{ background: "none" }}>
          {beautify(status)}
        </Tag>
      );
    case "pending":
    case "ended":
      return (
        <Tag color="black" style={{ background: "gray" }}>
          {beautify(status)}
        </Tag>
      );
    default:
      return <Tag style={{ background: "none" }}>{beautify(status)}</Tag>;
  }
};
